'use client';

import Image, { StaticImageData } from 'next/image';

import clsx from 'clsx';

import { Button } from '../../Components/Button';

import styles from './CreateKidsBanner.module.scss';

interface CreateKidsBannerProps {
  title: string;
  logo: StaticImageData;
  buttonText?: string;
  onClick?: () => void;
  className?: string;
}

export const CreateKidsBanner = ({ title, logo, buttonText, onClick, className }: CreateKidsBannerProps) => (
  <div className={clsx(styles.banner, className)}>
    {logo && <Image src={logo} alt="Pickatale Logo" width={logo.width} height={logo.height} className={styles.logo} />}

    <h1 className={styles.title}>{title}</h1>

    {buttonText && onClick && (
      <Button onClick={onClick} variant="outlined">
        {buttonText}
      </Button>
    )}
  </div>
);
